/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBipInfoModel } from '../../models/patient-bip-info-model';

export interface SavePatientBIPInfo$Params {
      body?: PatientBipInfoModel
}

export function SavePatientBIPInfo(http: HttpClient, rootUrl: string, params?: SavePatientBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBipInfoModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientBIPInfo.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientBipInfoModel>;
    })
  );
}

SavePatientBIPInfo.PATH = '/api/Staff/SavePatientBIPInfo';
